module.exports = __webpack_public_path__ + "static/media/LHAOutSwing.8ea8dee4.svg";